// extracted by mini-css-extract-plugin
export var cardHeader = "_id-0";
export var reorderHandle = "_id-3";
export var titleArea = "_id-1";
export var titleAreaWithHandle = "_id-2";